// extracted by mini-css-extract-plugin
export var chevronIcon = "_45-2";
export var teamName = "_45-1";
export var teamSwitcherButton = "_45-0";